import axios from 'axios'
import router from '../router'
import tokenService from '../services/token.service'
import accessCode from '@/localStorage/accessCode'
import store from '@/store/vuex'
import utils from '@/utils/utils'

var baseURL = import.meta.env.VITE_BASE_URL

const axiosConfig = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

let isProvidingNewAccessToken = false
let failedQueue = []

axiosConfig.interceptors.request.use(
  async (config) => {
    const token = tokenService.getJwtToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  },
)

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

axiosConfig.interceptors.response.use(
  async (res) => {
    return res
  },
  async (err) => {
    if (axios.isCancel(err)) {
      return Promise.reject(err)
    }

    const originalConfig = err.config
    const excludedUrls = [`api/Auth/login`, `api/Auth/validateOTPFor2Factor`]
    if (originalConfig && !excludedUrls.includes(originalConfig.url) && err.response) {
      if (err.response.status === 401) {
        if (isProvidingNewAccessToken) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject })
          })
            .then((token) => {
              originalConfig.headers.Authorization = 'Bearer ' + token
              return axiosConfig(originalConfig)
            })
            .catch((error) => {
              return Promise.reject(error)
            })
        }

        isProvidingNewAccessToken = true
        var tokens = {
          AccessToken: tokenService.getJwtToken(),
          RefreshToken: tokenService.getRefreshToken(),
        }
        return axios
          .post(baseURL + 'api/Auth/refresh-token', tokens)
          .then((response) => {
            tokenService.setJwtToken(response.data.AccessToken)
            tokenService.setRefreshToken(response.data.RefreshToken)
            processQueue(null, response.data.AccessToken)
            originalConfig.headers.Authorization = 'Bearer ' + response.data.AccessToken
            return axiosConfig(originalConfig)
          })
          .catch((_error) => {
            if (axios.isCancel(_error)) {
              return Promise.reject(_error)
            }
            tokenService.removeAuthTokens()
            accessCode.removeData()
            const role = store.state.user?.UserRoles?.[0]
            if (['Admin', 'Reports Viewer', 'Request Approver'].includes(role)) {
              router.push({ name: 'login' })
            } else {
              router.push({
                name: 'home',
                
              })
            }
            processQueue(_error, null)
            return Promise.reject(_error)
          })
          .finally(() => {
            isProvidingNewAccessToken = false
          })
      }
    }

    return Promise.reject(err)
  },
)

export const $axios = axiosConfig
